<div class="container">
  <h1 class="page-title">Demo</h1>

  <section class="box">
    <h2>Modal</h2>

    <div>
      <ng-template #shortContent let-modal>
        <div class="modal-header">
          <h4 class="modal-title">Content title</h4>
          <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="modal.dismiss()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book.
          </p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-dark"
            (click)="modal.close('Close button click')"
          >
            Close
          </button>
        </div>
      </ng-template>

      <button
        class="btn btn-lg btn-outline-primary"
        (click)="openModal(shortContent)"
      >
        Launch modal - short length
      </button>
    </div>

    <div>
      <ng-template #mediumContent let-modal>
        <div class="modal-header">
          <h4 class="modal-title">Content title</h4>
          <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="modal.dismiss()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book. It has survived not
            only five centuries, but also the leap into electronic typesetting,
            remaining essentially unchanged. It was popularised in the 1960s
            with the release of Letraset sheets containing Lorem Ipsum passages,
            and more recently with desktop publishing software like Aldus
            PageMaker including versions of Lorem Ipsum. Why do we use it? It is
            a long established fact that a reader will be distracted by the
            readable content of a page when looking at its layout. The point of
            using Lorem Ipsum is that it has a more-or-less normal distribution
            of letters, as opposed to using 'Content here, content here', making
            it look like readable English. Many desktop publishing packages and
            web page editors now use Lorem Ipsum as their default model text,
            and a search for 'lorem ipsum' will uncover many web sites still in
            their infancy. Various versions have evolved over the years,
            sometimes by accident, sometimes on purpose (injected humour and the
            like).
          </p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-dark"
            (click)="modal.close('Close button click')"
          >
            Close
          </button>
        </div>
      </ng-template>

      <button
        class="btn btn-lg btn-outline-primary"
        (click)="openModal(mediumContent)"
      >
        Launch modal - medium length
      </button>
    </div>

    <div>
      <ng-template #longContent let-modal>
        <div class="modal-header">
          <h4 class="modal-title">Content title</h4>
          <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="modal.dismiss()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book. It has survived not
            only five centuries, but also the leap into electronic typesetting,
            remaining essentially unchanged. It was popularised in the 1960s
            with the release of Letraset sheets containing Lorem Ipsum passages,
            and more recently with desktop publishing software like Aldus
            PageMaker including versions of Lorem Ipsum. Why do we use it? It is
            a long established fact that a reader will be distracted by the
            readable content of a page when looking at its layout. The point of
            using Lorem Ipsum is that it has a more-or-less normal distribution
            of letters, as opposed to using 'Content here, content here', making
            it look like readable English. Many desktop publishing packages and
            web page editors now use Lorem Ipsum as their default model text,
            and a search for 'lorem ipsum' will uncover many web sites still in
            their infancy. Various versions have evolved over the years,
            sometimes by accident, sometimes on purpose (injected humour and the
            like).
          </p>
          <p>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book. It has survived not
            only five centuries, but also the leap into electronic typesetting,
            remaining essentially unchanged. It was popularised in the 1960s
            with the release of Letraset sheets containing Lorem Ipsum passages,
            and more recently with desktop publishing software like Aldus
            PageMaker including versions of Lorem Ipsum. Why do we use it? It is
            a long established fact that a reader will be distracted by the
            readable content of a page when looking at its layout. The point of
            using Lorem Ipsum is that it has a more-or-less normal distribution
            of letters, as opposed to using 'Content here, content here', making
            it look like readable English. Many desktop publishing packages and
            web page editors now use Lorem Ipsum as their default model text,
            and a search for 'lorem ipsum' will uncover many web sites still in
            their infancy. Various versions have evolved over the years,
            sometimes by accident, sometimes on purpose (injected humour and the
            like).
          </p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-dark"
            (click)="modal.close('Close button click')"
          >
            Close
          </button>
        </div>
      </ng-template>

      <button
        class="btn btn-lg btn-outline-primary"
        (click)="openModal(longContent)"
      >
        Launch modal - long length
      </button>
    </div>

    <div>
      <ng-template #htmlContent let-modal>
        <div class="modal-header">
          <h4 class="modal-title">Content title</h4>
          <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="modal.dismiss()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p [innerHTML]="mockHtmlContent"></p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-dark"
            (click)="modal.close('Close button click')"
          >
            Close
          </button>
        </div>
      </ng-template>

      <button
        class="btn btn-lg btn-outline-primary"
        (click)="openModal(htmlContent)"
      >
        Launch modal - Dynamic HTML content
      </button>
    </div>
  </section>

  <section class="box">
    <h2>Download PDF</h2>

    <button (click)="downloadPDFLocal()">
      Download PDF (hosted at same domain)
    </button>
    <div class="note">Download directly for chrome and firefox</div>
    <br /><br />
    <button (click)="downloadPDFExternal()">
      Download PDF (hosted at external domain)
    </button>
    <div class="note">
      Depends on user's browser settings, by default it opens in new tab for
      chrome and firefox.
    </div>
    <br />
    <div>
      <a href="https://stackoverflow.com/a/55609032" target="_blank">Source</a>
      <div>
        >> Setting -> Advanced -> Privacy & security -> Content setting -> PDF
        Documents, You see "Download PDF files instead of automatically opening
        them in Chrome" Enable it.
      </div>
    </div>
  </section>

  <section class="box">
    <h2>Relative time ago</h2>
    <div *ngFor="let dateString of dateStrings">
      <div>{{ dateString | timeAgo }}</div>
      <div style="font-size: 12px">{{ dateString }}</div>
      <br />
    </div>
  </section>

  <section class="box">
    <h2>Login Page Velocity Button Text</h2>
    Font Weight: 400 Regular
    <app-red-button class="fw-400">Login with OCBC Velocity</app-red-button>
    Font Weight: 600 Semibold
    <app-red-button class="fw-600">Login with OCBC Velocity</app-red-button>
    Font Weight: 700 Bold
    <app-red-button class="fw-700">Login with OCBC Velocity</app-red-button>
  </section>
</div>
